import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllQuiz, getFunFact, getProfile } from '../http/http';
import Header from '../components/Header';
import Lottie from 'lottie-react';
import RewardsAnimation from "../animations/rewards.json";
import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-cube";
import BottomNavbar from '../components/BottomNavbar';
import MediumLoader from '../components/Loaders/MediumLoader';
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { imageBaseUrl } from '../utils/constants';
import snowfallAnimation from "../animations/snowfall-animation.json";
import starsAnimation from "../animations/starsAnimation.json";
import wordAnimation from "../animations/guessWordAnimation.json";
import gridAnimation from "../animations/gridAnimation.json";

const HomePage = () => {
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const navigate = useNavigate();
    const [userProfile, setUserProfile] = useState(null);
    const [funFact, setFunFact] = useState(null);
    const [popularQuizes, setPopularQuizes] = useState(null);
    const [featuredQuizes, setFeaturedQuizes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [randomText, setRandomText] = useState(null);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { selectedLanguage } = useSelector(state => state?.languageSlice);

    const fetchUserProfile = async () => {
        try {
            const response = await getProfile(userToken);
            setUserProfile(response?.data?.result);
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    const fetchFunFact = async () => {
        const totalFacts = localStorage.getItem("total_facts");
        const randomIndex = Math.floor(Math.random() * (totalFacts - 1 + 1)) + 1;
        setRandomText("fun_fact_" + randomIndex);
    }

    const fetchAllQuizes = async () => {
        try {
            setLoading(true);
            const response = await getAllQuiz(selectedLanguage, userToken);
            setLoading(false);
            setPopularQuizes(response?.data?.result?.filter((data) => data?.isPopular));
            setFeaturedQuizes(response?.data?.result?.filter((data) => data?.isFeatured));
        } catch (error) {
            setLoading(false);
            toast.error(t("86"));
        }
    }

    useEffect(() => {
        if (userToken) {
            fetchUserProfile();
            fetchAllQuizes();
            fetchFunFact();
        }
        else {
            navigate("/")
        }
    }, [userToken, selectedLanguage]);

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.profile_section}>
                    <div className={classes.profile_sub_section}>
                        <div className={classes.profile_avatar}>
                            <img src={userProfile?.image ?? "/assets/images/dummy.png"} alt={userProfile?.name ?? t("1")} className={classes.avatar_image} />
                        </div>
                        <div className={classes.profile_details}>
                            <p className={classes.profile_text}>{userProfile?.name ?? t("1")}</p>
                            <p className={classes.profile_text}>{userProfile?.msisdn}</p>
                        </div>
                    </div>

                    <div className={classes.user_points_container}>
                        <div className={classes.rewards_animation}>
                            <Lottie animationData={RewardsAnimation} loop autoPlay className={classes.animation} />
                        </div>
                        <p className={classes.points}>{userProfile?.total_points} {t("2")}</p>
                    </div>

                </div>
            </div>

            <div className={classes.fun_fact_container}>
                <img src="/assets/images/fun-fact.png" alt="fun" className={classes.fun_fact_image} />
                <p className={classes.fun_fact}>{t(randomText)}</p>
            </div>

            <div className={`${classes.container} ${classes.no_padding}`}>
                <h1 className={classes.quiz_category_heading}>{t("3")}</h1>

                <div className={classes.carousel_section}>
                    {loading ? <MediumLoader /> : popularQuizes &&

                        <Swiper
                            modules={[
                                Autoplay,
                                EffectCoverflow,
                            ]}
                            loop
                            effect={"coverflow"}
                            coverflowEffect={{
                                slideShadows: false,
                                rotate: 40
                            }
                            }
                            spaceBetween={10}
                            slidesPerView={3}
                            // navigation
                            autoplay={{
                                delay: 500,
                                disableOnInteraction: false,
                            }}
                            // pagination={{ clickable: true }}
                            // scrollbar={{ draggable: true }}
                            onSwiper={(swiper) => null}
                            onSlideChange={() => null}
                        >
                            {popularQuizes && popularQuizes?.map((dataItem, i) => {
                                return (
                                    <SwiperSlide>
                                        <div
                                            className={classes.quiz_card}
                                            key={i}
                                            onClick={() => navigate("/quiz-details", {
                                                state: dataItem
                                            })}
                                        >
                                            <div className={classes.quiz_image}>
                                                <img
                                                    className={classes.image}
                                                    alt={dataItem?.name}
                                                    src={dataItem?.image ? `${imageBaseUrl}${dataItem?.image}` : "/assets/images/download.png"}
                                                />
                                            </div>
                                            <h3 className={classes.text}>{dataItem.name}</h3>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    }
                </div>
            </div>

            <div className={classes.word_game_container}>
                <div className={classes.word_game_sub_container}>
                    <Lottie animationData={starsAnimation} loop autoPlay className={classes.animation_stars} />
                </div>

                <div className={classes.grid_animation_container}>
                    <Lottie animationData={gridAnimation} loop autoPlay className={classes.grid_animation} />
                </div>

                <div className={classes.photo_container}>
                    <Lottie animationData={wordAnimation} loop autoPlay className={classes.photo} />
                </div>

                <div className={classes.word_game_content}>
                    <h1 className={classes.word_game_heading}>{t("127")}
                    </h1>
                    <p className={classes.word_game_text}>{t("128")}</p>
                    <button type="button" className={classes.word_play_btn}
                        onClick={() => {
                            navigate("/word-game-details")
                        }}
                    >
                        {t("129")}
                    </button>
                </div>
            </div>


            <div className={`${classes.container}`}>
                <h1 className={classes.quiz_category_heading2}>{t("4")}</h1>
                {loading ? <MediumLoader /> : (
                    <>

                        <div className={classes.grid_section}>
                            {featuredQuizes && featuredQuizes?.slice(0, 20).map((dataItem, idx) => {
                                return (
                                    <div className={classes.grid_item} key={idx}
                                        onClick={() => navigate("/quiz-details", {
                                            state: dataItem
                                        })}
                                    >
                                        <div className={classes.grid_item_quiz_image}>
                                            <img
                                                className={classes.grid_item_image}
                                                alt={dataItem?.name}
                                                src={dataItem?.image ? `${imageBaseUrl}${dataItem?.image}` : "/assets/images/download.png"}
                                                loading='lazy'
                                            />
                                        </div>
                                        <h3 className={classes.quiz_text}>{dataItem.name}</h3>
                                    </div>
                                )
                            })}
                        </div>
                        {/*<div className={classes.button_container}>
                            <button type='button' className={classes.more_btn} onClick={() => navigate("/all-quizes")}>
                                {t("5")}
                            </button>
                        </div>*/}
                    </>
                )
                }
            </div>

            <div className={classes.word_game_container}>
                <div className={classes.word_game_sub_container}>
                    <Lottie animationData={starsAnimation} loop autoPlay className={classes.animation_stars} />
                </div>

                <div className={classes.grid_animation_container}>
                    <Lottie animationData={gridAnimation} loop autoPlay className={classes.grid_animation} />
                </div>

                <div className={classes.photo_container}>
                    <Lottie animationData={wordAnimation} loop autoPlay className={classes.photo} />
                </div>

                <div className={classes.word_game_content}>
                    <h1 className={classes.word_game_heading}>{t("130")}
                    </h1>
                    <p className={classes.word_game_text}>{t("131")}</p>
                    <button type="button" className={classes.word_play_btn}
                        onClick={() => {
                            navigate("/xo-game-details")
                        }}
                    >
                        {t("132")}
                    </button>
                </div>
            </div>

            {featuredQuizes?.slice(20, 40)?.length > 0 &&
                <div className={`${classes.container}`}>
                    <h1 className={classes.quiz_category_heading2}>{t("5")}</h1>
                    {loading ? <MediumLoader /> : (
                        <>

                            <div className={classes.grid_section}>
                                {featuredQuizes?.slice(20, 40)?.length > 0 && featuredQuizes?.slice(20, 40).map((dataItem, idx) => {
                                    return (
                                        <div className={classes.grid_item} key={idx}
                                            onClick={() => navigate("/quiz-details", {
                                                state: dataItem
                                            })}
                                        >
                                            <div className={classes.grid_item_quiz_image}>
                                                <img
                                                    className={classes.grid_item_image}
                                                    alt={dataItem?.name}
                                                    src={dataItem?.image ? `${imageBaseUrl}${dataItem?.image}` : "/assets/images/download.png"}
                                                    loading='lazy'
                                                />
                                            </div>
                                            <h3 className={classes.quiz_text}>{dataItem.name}</h3>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className={classes.button_container}>
                                <button type='button' className={classes.more_btn} onClick={() => navigate("/all-quizes")}>
                                    {t("5")}
                                </button>
                            </div>
                        </>
                    )
                    }
                </div>
            }

            {selectedLanguage == 0 && (
                <div className={classes.container_reverse_quiz}>
                    <div className={classes.animations}>
                        <Lottie
                            animationData={snowfallAnimation}
                            loop
                            autoPlay
                            className={classes.animation_2}
                        />
                    </div>
                    <img src="/assets/images/reverse_quiz_emoji_2.png" alt="reverse emoji" className={classes.emoji} />
                    <div className={classes.reverse_quiz_heading_container}>
                        <h1 className={classes.reverse_quiz_heading}>
                            {t("133")}
                        </h1>
                        <p className={classes.reverse_quiz_paragraph}>
                            {t("134")}
                        </p>
                        <button className={classes.play_btn} onClick={() => navigate("/reverse-quiz")}>
                            {t("135")}
                        </button>
                    </div>

                </div>
            )}


            <BottomNavbar active={0} />
        </>
    )
}

export default HomePage